import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';

import { commonActions } from '../../../_actions';

class DataTableContainer extends Component {
    componentDidMount() {
        this.props.dispatch(commonActions.getAll('SubCategory'));
        this.props.dispatch(commonActions.getAll('CostUnit'));
    }

    render() {
        const { common } = this.props;

        const columns_subcategory = [
            {
                name: "Define Id",
                options: {
                    filter: true,
                    sort: true,
                    sortDirection: 'desc',
                    filterType: 'textField',
                }
            },
            "Common Value",
            {
                name: "Common Locate",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                }
            },
            "Common Status",
        ];

        let data_subcategory = common.items_subcategory && common.items_subcategory.map(item => {
            return [
                item.DefineId,
                item.DefineValue1,
                item.CommonLocate,
                item.CommonStatus,
            ]
        })

        const columns_costunit = [
            {
                name: "成本單位編號",
                options: {
                    filter: true,
                    sort: true,
                    sortDirection: 'desc',
                    filterType: 'textField',
                }
            },
            "成本單位命名",
            {
                name: "成本單位區域",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                }
            },
            "Common Status",
        ];

        let data_costunit = common.items_costunit && common.items_costunit.map(item => {
            return [
                item.CostUnitId,
                item.DefineValue2,
                item.CommonLocate,
                item.CommonStatus,
            ]
        })

        const options = {
            filter: true,
            selectableRows: false,
            filterType: "dropdown",
            responsive: "stacked",
            rowsPerPage: 10,
        };

        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <MUIDataTable
                            title={"服務類別"}
                            data={data_subcategory}
                            columns={columns_subcategory}
                            options={options}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <MUIDataTable
                            title={"成本單位"}
                            data={data_costunit}
                            columns={columns_costunit}
                            options={options}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { common } = state;

    return {
        user,
        common
    };
}

export default connect(mapStateToProps)(DataTableContainer);


// WEBPACK FOOTER //
// ./src/components/AdminDashboard/Settings/DataTableContainer.js